import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

@Component({
  selector: 'app-king-weapon',
  templateUrl: './king-weapon.component.html',
  styleUrls: ['./king-weapon.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KingWeaponComponent {
  readonly weapon = input.required<string>();
  readonly reverse = input.required<boolean>();

  public readonly weaponStyle = computed(
    () => `background-image: url(assets/images/king/${this.weapon()}.png)`
  );
}
